import React from 'react';
import { Route } from 'react-router-dom';
import ReactGA from 'react-ga';
import { SeoRuta } from './seo';

// Todas las rutas pasan por aquí: registra la visita en GA y pone título/descripción/canonical de seoRutas.json
export const RutaAnalytics = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => {
                ReactGA.pageview(props.location.pathname);
                return (
                    <>
                        <SeoRuta pathname={props.location.pathname} />
                        <Component {...props} />
                    </>
                );
            }}
        />
    )
}
